
/*  eslint-disable */
// @ts-nocheck # 
import {createApp, computed, ComputedRef, defineComponent, reactive, onMounted, ref, nextTick, getCurrentInstance, watch} from 'vue'
import * as images from './images.ts';
import utils from './index';

interface State {
    isInitSDK: boolean; // 是否已引入SDK
    player: any; // 播放器对象
    isShowPlayer: boolean; // 是否初始化完成播放器
    loadingImgSrc: string;
    backgroundImg: string;
    imgInImg: string;
    imgCover: string;
    restoreImg: string;
    id: string; // 容器id 动态复值 保证唯一性
    showPlayerTip: boolean; // 是否展示视频播放提示文字
    setSpeed: number;//设置倍速
    isFloat: boolean; // 是否已开启浮动播放器
    isDrag: boolean; // 是否开启拖拽功能
    videoBox: any; // 播放器dom
    videoBoxParentNode: any; // 播放器父级组件dom
}
export default defineComponent({
    name: 'DetectPlayer',
    props: {
        playData: {
            type: Object,
            default: function () {
                return {
                    playAuth: '',
                    vodId: '',
                    cover: '',
                    autoplay: false,
                    size: 0, // 视频大小 M
                };
            }
        },
        tipPosition: {
            type: Object,
            default: function () {
                return {
                    marginLeft: 0,
                    marginBottom: -96,
                }
            }
        },
        seek: {
            type: Number,
            default: 0
        },
        speedList: {
            type: Array,
            default: function(){
                return []
            }
        },
        isShowFloat:{
            type:Boolean,
            default: function(){
                return false
            }
        },
        vid: {
            type:String,
            default: function(){
                return ''
            }
        }
    },
    setup(props: any, ctx: any) {
        let state: State = reactive({
            isInitSDK: false, // 是否已引入SDK
            player: null, // 播放器对象
            isShowPlayer: false, // 是否初始化完成播放器
            loadingImgSrc: images.loadingImg,
            backgroundImg: images.backgroundImg,
            imgInImg: images.imgInImg,
            imgCover: images.imgCover,
            restoreImg: images.restoreImg,
            id: `v${props.vid}` || 'CYP_DETECT_player', // 容器id 动态复值 保证唯一性
            showPlayerTip: false, // 是否展示视频播放提示文字
            setSpeed: 1,//设置倍速
            isFloat:false, // 是否已开启浮动播放器
            isDrag:false, // 是否开启拖拽功能
            videoBox:null, // 播放器dom
            videoBoxParentNode: null, // 播放器父级组件dom
        })
        /**
         * 数据初始化
         * */
        const clearAllData = function(e = null) {
            if (state.player) {
                state.player.pause();
                state.player.dispose();
            }
            state.player = null;
            state.isShowPlayer = false;
            if (e && typeof e === 'function') {
                e('success')
            }
        }
        const playDataObj = computed(function () {
            console.log('aaaaaaa');
            return JSON.parse(JSON.stringify(props.playData)) || null;
        })
        /**
         * 播放视频
         * */
        const playVideo = function() {
            state.player.play()
        };
        /**
         * 暂停播放
         * */
        const pauseVideo= function(){
            state.player.pause();
        };
        /**
         * 浮动状态下切换视频播放器背景图换成视频首图或默认背景图
         * */
        const showPlayerBackgroundImg= function(){
            let CYP_prismPlayer = document.getElementsByClassName('CYP_prismPlayer')[0]
            let top = CYP_prismPlayer.offsetTop; //
            let left = CYP_prismPlayer.offsetLeft;
            let model = document.getElementsByClassName('prism-player-default')[0]
            model.style.top = `${top}px`;
            model.style.left = `${left}px`;
            model.className = 'prism-player-default prism-player-default__float';
        };
        /**
         * 关闭画中画功能
         * 向外抛出事件
         * */
        const restoreImgInImg = function () {
            let _this = this
            let videoBox = document.getElementById(`${state.id}`);
            // 去掉浮动样式
            videoBox.className = 'CYP_prismPlayer prism-player'

            state.isFloat = false; // 表明关闭浮动状态

            nextTick(() => {
                // 隐藏还原按钮
                let CYP__restoreBtn = document.getElementById('CYP__restoreBrn')
                CYP__restoreBtn.style.display = 'none'
                // 展示浮动按钮
                let floatBtn = document.getElementById('CYP__FloatBrn')
                if(floatBtn){
                    floatBtn.style.display = 'block'
                }else{
                    initFloatBtn();
                }
                // 播放器dom还原
                state.videoBoxParentNode.insertBefore(state.videoBox,state.videoBoxParentNode.childNodes[1]);
                // 加载框位置还原
                let model = document.getElementsByClassName('prism-player-default')[0]
                model.style.top = `auto`;
                model.style.left = `auto`;
                model.className = 'prism-player-default';
            })
        };
        /**
         * 创建还原按钮
         * */
        const createRestoreBtn = function (){
            let _this = this;
            let btn = document.createElement('div')
            btn.style.backgroundImage = `url(${state.restoreImg})`;
            btn.className = 'ui__FloatBtn ui__restoreBtn'
            btn.id = 'CYP__restoreBrn'
            btn.onclick = () => {
                // 关闭画中画功能
                restoreImgInImg()
            }
            let prismControlbar = document.getElementsByClassName('prism-controlbar')[0]
            prismControlbar.appendChild(btn)
        };
        /**
         * 开启画中画功能
         * 向外抛出事件
         * */
        const initImgInImg = function (){
            let _this = this
            let videoBox = document.getElementById(`${state.id}`);
            if(videoBox){
                state.videoBox = videoBox
                // 已有播放器增加浮动样式
                state.videoBox.className += ' ui__initFloat';

                state.isFloat = true; // 表明开启浮动状态
                // 隐藏浮动按钮
                let floatBtn = document.getElementById('CYP__FloatBrn')
                floatBtn.style.display = 'none'

                nextTick(()=>{
                    // 展示还原按钮
                    let CYP__restoreBtn = document.getElementById('CYP__restoreBrn')
                    // console.log(CYP__restoreBtn)
                    if(CYP__restoreBtn){
                        CYP__restoreBtn.style.display = 'block'
                    } else{
                        // 创建还原按钮
                        createRestoreBtn();
                    }
                    // 开启浮动后整个播放器dom层级变为body的子节点
                    state.videoBoxParentNode = state.videoBox.parentNode
                    state.videoBoxParentNode.removeChild(state.videoBox)
                    document.getElementsByTagName('body')[0].appendChild(state.videoBox)
                })
            }
        };
        /**
         * 创建浮动按钮节点
         * */
        const initFloatBtn = function () {
            let _this = this
            // 按钮
            let btn = document.createElement('div')
            btn.style.backgroundImage = `url(${state.imgInImg})`;
            btn.className = 'ui__FloatBtn'
            btn.id = 'CYP__FloatBrn'
            btn.onclick = () => {
                initImgInImg()
            }
            let prismControlbar = document.getElementsByClassName('prism-controlbar')[0]
            prismControlbar.appendChild(btn)
        };
        /**
         * 创建倍速按钮节点
         * */
        const initSpeedBtn = function (list) {
            let _this = this
            // 倍速按钮列表
            let btnBox = document.createElement('div')
            btnBox.className = 'ui__speed_btnList'
            let prismControlbar = document.getElementsByClassName('prism-controlbar')[0]
            // 倍速按钮构造方法
            const SpeedBtn = function (speed) {
                let btn = document.createElement('div')
                btn.innerHTML = `${speed}x`
                btn.className = 'ui__speed_btn'
                btn.onclick = () => {
                    state.setSpeed = speed
                    // 当前节点的所有兄弟节点的calss='ui__speed_btn',当前节点class='ui__speed_btn ui__speed_btn_act';
                    for(let i=0;i<btn.parentNode.children.length;i++){
                        let item = btn.parentNode.children[i];
                        item.className = 'ui__speed_btn'
                    }
                    btn.className = 'ui__speed_btn ui__speed_btn_act'
                }
                return btn
            }
            let btnList = list.map(item => {
                return new SpeedBtn(item)
            })
            btnList.forEach(item => {
                btnBox.appendChild(item)
            })
            prismControlbar.appendChild(btnBox)
        };
        /**
         * 初始化播放器
         * */
        const initPlayer = function () {
            let _this = this;
            // 初始化播放器
            state.player = new Aliplayer({
                'id': state.id,
                'vid': props.playData.vodId, // vodId 必传
                'playauth': props.playData.playAuth, // playAuth 必传
                'cover': (props.playData && props.playData.cover) || '', // 封面图选传
                'width': '100%',
                'height': '100%',
                'autoplay': props.playData.autoplay || false, // 自动播放选传 默认false
                'useH5Prism': true,
                'accId': '',
                'accSecret': '',
                'stsToken': '',
                'domainRegion': '',
                'authInfo': '',
                'accessKeyId': '',
                'securityToken': '',
                'accessKeySecret': '',
                'x5_orientation': 'portraint',
                'definition': 'FD,LD,SD,HD,OD',
                'defaultDefinition': 'LD',
            }, function () {
                let args = {
                    eventType: 1,
                    eventName: 'onReady' // 初始化成功
                }
                console.log('视频初始化成功');
                ctx.emit('playerEvent', args);
                state.isShowPlayer = true;
            });
            // 准备好了
            state.player.on('ready', () => {
                let args = {
                    eventType: 1,
                    eventName: 'onReady' // 准备好了
                }
                ctx.emit('playerEvent', args);
                // 移动端提示消耗流量
                if (props.playData &&  props.playData.size && utils.getUserBrowser() === 0) {
                    state.showPlayerTip = false;
                }
                // 倍速按钮
                if(props.speedList && props.speedList.length > 0){
                    nextTick(() => {
                        _this.initSpeedBtn(props.speedList)
                    })
                }
                // 浮动按钮
                if(props.isShowFloat && !_this.state.isFloat){
                    nextTick(() => {
                        _this.initFloatBtn()
                    })
                }else if(props.isShowFloat && _this.state.isFloat){
                    // 浮动状态下切换视频则初始化还原按钮
                    nextTick(()=>{
                        _this.createRestoreBtn()
                    })
                }
            });
            // 开始播放事件
            state.player.on('play', () => {
                let args = {
                    eventType: 2,
                    eventName: 'onPlay', // 开始播放
                    eventValue: state.player.getCurrentTime()
                }
                ctx.emit('playerEvent', args);
                state.showPlayerTip = false;
            });
            // 暂停事件
            state.player.on('pause', () => {
                if (state.player) { // 因为在销毁播放器时会先暂停然后再销毁此时_this.player.getCurrentTime()会造成空指针
                    let args = {
                        eventType: 3,
                        eventName: 'onPause', // 暂停
                        eventValue: state.player.getCurrentTime()
                    }

                    ctx.emit('playerEvent', args);
                }
            });
            // 缓冲事件
            state.player.on('waiting', () => {
                let args = {
                    eventType: 4,
                    eventName: 'onWaiting', // 缓冲
                    eventValue: state.player.getCurrentTime()
                }
                ctx.emit('playerEvent', args);
            });
            // 当前视频播放完毕时触发。
            state.player.on('ended', () => {
                let args = {
                    eventType: 5,
                    eventName: 'onEnded', // 播放完毕
                    eventValue: state.player.getCurrentTime()
                }
                ctx.emit('playerEvent', args);
            });
            // 全屏事件
            state.player.on('requestFullScreen', () => {
                let args = {
                    eventType: 6,
                    eventName: 'onRequestFullScreen', // 全屏事件
                    eventValue: state.player.getCurrentTime()
                }
                ctx.emit('playerEvent', args);
            });
            // 安卓 取消全屏事件 iOS下不会触发，仅H5支持。
            state.player.on('cancelFullScreen', () => {
                let args = {
                    eventType: 7,
                    eventName: 'onCancelFullScreen', // 取消全屏事件
                    eventValue: state.player.getCurrentTime()
                }
                ctx.emit('playerEvent', args);
            });
            //  开始拖拽，参数返回拖拽点的时间。
            state.player.on('startSeek', (res) => {
                let args = {
                    eventType: 8,
                    eventName: 'onStartSeek', // 开始拖拽
                    eventValue: res
                }
                ctx.emit('playerEvent', args);
            });
            //  完成拖拽，参数返回拖拽点的时间。
            state.player.on('completeSeek', (res) => {
                let args = {
                    eventType: 9,
                    eventName: 'onCompleteSeek', // 完成拖拽
                    eventValue: res
                }
                ctx.emit('playerEvent', args);
            });
        };
        /**
         * 引入sdk
         * */
        const addSDKScript = function () {
            let _this = this;
            let scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                let item = scripts[i]
                if (item.getAttribute('id') === 'cyp_aliyunplayerSDK') {
                    state.isInitSDK = true;
                    break;
                }
            }
            if (state.isInitSDK === false) {
                // 没有引入sdk 则进行引入
                let link = document.createElement('link')
                link.rel = "stylesheet"
                link.href = 'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css'
                document.head.appendChild(link);
                let sdkSrc = "https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js";
                let script = document.createElement("script");  //创建一个script标签
                script.setAttribute("type", "text/javascript");
                script.setAttribute("id", "cyp_aliyunplayerSDK");
                script.setAttribute("charset", "utf-8");
                script.onload = function () {
                    // 初始化播放器对象
                    initPlayer()
                }
                script.src = sdkSrc;
                document.head.appendChild(script)
            } else {
                // 引入sdk了 查看播放器构造函数有没有生成 如果没有的话则等待1秒后再查看直到生成
                // console.log('引入sdk了 初始化sdk')
                clearAllData((e) => {
                    if (e && e === 'success') {
                        // console.log('数据初始化成功')
                        if (props.playData.playAuth && props.playData.vodId) {
                            setTimeout(() => {
                                initPlayer();
                            }, 500)
                        }
                    }
                })
            }
        };
        watch(playDataObj, (val, oldVal) => {
            let _this = this;
            console.log('watch====playDataObj');
            console.log(val);
            console.log(oldVal);
            if (!oldVal && !state.player) {
                state.isShowPlayer = false
                clearAllData((e) => {
                    if (e && e === 'success') {
                        console.log('数据初始化成功1')
                        console.log(val);
                        if (val.playAuth && val.vodId) {
                            setTimeout(() => {
                                addSDKScript();
                            }, 500)
                        }
                    }
                })
                return
            }
            if (val && val.playAuth && oldVal && oldVal.playAuth) {
                if (val.playAuth !== oldVal.playAuth) {
                    // console.log('换碟')
                    //  浮动状态下切换视频播放器背景图换成视频首图或默认背景图
                    if(_this.isFloat){
                        _this.showPlayerBackgroundImg()
                    }
                    // console.log(val)
                    // _this.isShowPlayer = false
                    clearAllData((e) => {
                        if (e && e === 'success') {
                            console.log('数据初始化成功2')
                            if (val.playAuth && val.vodId) {
                                setTimeout(() => {
                                    _this.initPlayer();
                                }, 500)
                            }
                        }
                    })
                }
            }
        }, {deep: true})
        // watch(props.seek, function(data) {
        //     if (state.player) {
        //         state.player.seek(data)
        //     };
        // }, {deep: true, immediate: true})
        watch((props.seek), (data) =>  {
            if (state.player) {
                state.player.seek(data)
            };
        }, {deep: true, immediate: true})
        watch(state.setSpeed, function(data) {
            if (state.player) {
                state.player.setSpeed(data);
            }
        }, {deep: true, immediate: true})
        watch(state.isFloat, function(data) {
            let _this = this;
            state.isDrag = data
            // 关闭拖拽功能 播放器回到初始位置
            nextTick(()=>{
                if(!state.isDrag){
                    let videoBox = document.getElementById(`${state.id}`);
                    videoBox.style.left = 'auto'
                    videoBox.style.top = '0px'
                }
            })

            let args = {
                eventType: data ? 10 : 11,
                eventName: data ? 'showFloat' : 'closeFloat'
            }
            ctx.emit('playerEvent', args);
        }, {deep: true, immediate: true})
        return {
            state,
            playDataObj,
            clearAllData,
            addSDKScript,
            initPlayer,
            initSpeedBtn,
            initFloatBtn,
            initImgInImg,
            createRestoreBtn,
            restoreImgInImg,
            playVideo,
            pauseVideo,
            showPlayerBackgroundImg,
        }
    },
    methods: {
            
            
            
            
            
            
            
            
        }

})
